
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeatGoogle as ObiHeatGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heat-google.js';
 
 
 

 
 export const ObiHeatGoogle = createComponent({
   react: React,
   tagName: 'obi-heat-google',
   elementClass: ObiHeatGoogleElement,
   events: {
     
   }
  });
 
 